// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__kaeOw","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1Ymip"};